var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSyncing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "20px",
    viewBox: "0 0 17 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Navigation / Sidebar / Compact / Components / Category / 01. Default 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "02.-Work-Orders-/-02.-Scoping-/-Offline-Mode",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 4,
    transform: "translate(-412.000000, -832.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-/-Sidebar-/-Compact-/-Desktop",
    transform: "translate(384.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-/-Sidebar-/-Compact-/-Components-/-Category-/-01.-Default",
    transform: "translate(0.000000, 818.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 72,
    height: 48
  }), /*#__PURE__*/React.createElement("g", {
    id: "Atoms-/-Icons-/-House-/-01.-Outline",
    transform: "translate(24.500000, 12.000000)",
    fill: "#007AFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.99,4 L11.99,2 L7.99,5 L11.99,8 L11.99,6 C15.3,6 17.99,8.69 17.99,12 C17.99,13.01 17.74,13.97 17.29,14.8 L18.75,16.26 C19.53,15.03 19.99,13.57 19.99,12 C19.99,7.58 16.41,4 11.99,4 Z M11.99,18 C8.68,18 5.99,15.31 5.99,12 C5.99,10.99 6.24,10.03 6.69,9.2 L5.23,7.74 C4.45,8.97 3.99,10.43 3.99,12 C3.99,16.42 7.57,20 11.99,20 L11.99,22 L15.99,19 L11.99,16 L11.99,18 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,10 C10.9,10 10,10.9 10,12 C10,13.1 10.9,14 12,14 C13.1,14 14,13.1 14,12 C14,10.9 13.1,10 12,10 Z",
    id: "Path"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncing);
export default __webpack_public_path__ + "static/media/syncing.a42bab109add59f8562d174e4735ed1d.svg";
export { ForwardRef as ReactComponent };